import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';


const enUs = 'en-US';

const d2cOptions = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: ({ data }) => {
      if (
        !data ||
        !data.target ||
        !data.target.fields ||
        !data.target.fields.file
      ) {
        return null;
      }

      let alt = '';

      if (data.target.fields.title && data.target.fields.title[enUs]) {
        alt = data.target.fields.title[enUs];
      }

      return (
        <img className="richTextImg" alt={alt} src={data.target.fields.file[enUs].url} />
      );
    }
  }
};

function RichText({ json }) {
  return documentToReactComponents(json, d2cOptions);
}

export default RichText;